// extracted by mini-css-extract-plugin
export default {"container":"VGfzfr3oC1Rs3vS0DsyE","text":"Hltc_CnY9gq3Q3SsTqdT"};